import axios from '@/api.js'
import util from './util.js'

const priv = {}
priv.checkPriv = async function(opt){
    let result =  await axios.get(`/front/priv?handle=${opt}`).then(resp => resp.data)
    if('ok' === result) {
        return true;
    } else if ('needLogin' === result) {
        util.showSuccessMessage('您还没有登录，请先登录！');
        location.href = './login.html'
    } else if ('noPass' === result) {
        location.href = './personalInformation.html'
    } else if ('noAllPrivByNoInfor' == result) {
        util.showSuccessMessage('您的账号还未完善过个人信息，请先完善个人信息！');
        setTimeout(function(){location.href ='./personalInformation.html'},3000);
    } else if ('noViewPriv' == result || 'noAddPriv' == result || 'noAllPriv' == result) {
        util.showSuccessMessage('您的账号还没有审核通过，请等待审核。如有疑问，请联系系统管理员！');
    } else if ('noAuditPriv' === result) {
        util.showSuccessMessage('您没有审核权限！');
    } else if ('noPublishPriv' === result){
        util.showSuccessMessage('您没有发布权限！');
    } else if ('noDisTributePriv' === result){
        util.showSuccessMessage('您没有分配权限！');
    } else if ('disable' === result) {
        util.showSuccessMessage('您的账号已经停用请联系管理员');
    } else {
        util.showSuccessMessage('您没有操作权限！');
    }
    return false;
}

priv.checkCaseAudit = async function() {
    let result =  await axios.get(`/front/priv/checkCaseAuditPriv`).then(resp => resp.data)
    return result.data
}
priv.checkButtonPriv = async function() {
    let result =  await axios.get(`/front/button`).then(resp => resp.data)
    return result.data
}
export default priv


// WEBPACK FOOTER //
// ./src/utils/priv.js